import { graphql } from 'gql';

export const priceListRatio = graphql(`
    query uerPriceListRatioRows(
        $contractId: Long!
        $order: [PriceListRatioCoefficientRowDataSortInput!]
        $skip: Int
        $take: Int
        $where: PriceListRatioCoefficientRowDataFilterInput
    ) {
        uerPriceListRatioRows(contractId: $contractId, order: $order, skip: $skip, take: $take, where: $where) {
            totalCount
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                code
                id
                isIncludedInAct
                isIncludedInWorkOrder
                isIncludedInWorkOrderChange
                justification
                kem
                kmat
                knr
                kozp
                ksp
                ktz
                ktzzpm
                status
                workConditions
            }
        }
    }
`);

export const uerPriceListRatioUerRowsGql = graphql(`
    query uerPriceListRatioUerRows(
        $order: [PriceListRatioUerRowDataSortInput!]
        $ratioRowId: Long!
        $skip: Int
        $take: Int
        $where: PriceListRatioUerRowDataFilterInput
    ) {
        uerPriceListRatioUerRows(order: $order, ratioRowId: $ratioRowId, skip: $skip, take: $take, where: $where) {
            totalCount
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                appliesToCode
                appliesToCodeName
                appliesToId
                appliesToLinkStatus
                ratioRowId
            }
        }
    }
`);

export const priceListRatioSectionNameFilter = graphql(`
    query uerPriceListRatioSectionNameFilter($contractId: Long!, $where: FilterValueOfStringFilterInput) {
        uerPriceListRatioSectionNameFilter(contractId: $contractId, where: $where, take: 1000) {
            totalCount
            items {
                value
            }
        }
    }
`);

export const priceListRatioGroupFullNameFilter = graphql(`
    query uerPriceListRatioGroupFullNameFilter($contractId: Long!, $where: FilterValueOfStringFilterInput) {
        uerPriceListRatioGroupFullNameFilter(contractId: $contractId, where: $where, take: 1000) {
            totalCount
            items {
                value
            }
        }
    }
`);

export const priceListRatioAppliesToFullNameFilter = graphql(`
    query uerPriceListRatioAppliesToFullNameFilter($contractId: Long!, $where: FilterValueOfStringFilterInput) {
        uerPriceListRatioAppliesToFullNameFilter(contractId: $contractId, where: $where, take: 1000) {
            totalCount
            items {
                value
            }
        }
    }
`);

export const priceListRatioCodeFilter = graphql(`
    query uerPriceListRatioCodeFilter($contractId: Long!, $where: FilterValueOfStringFilterInput) {
        uerPriceListRatioCodeFilter(contractId: $contractId, where: $where, take: 1000) {
            totalCount
            items {
                value
            }
        }
    }
`);

export const priceListRatioWorkConditionsFilter = graphql(`
    query uerPriceListRatioWorkConditionsFilter($contractId: Long!, $where: FilterValueOfStringFilterInput) {
        uerPriceListRatioWorkConditionsFilter(contractId: $contractId, take: 1000, where: $where) {
            totalCount
            items {
                value
            }
        }
    }
`);

export const priceListRatioWorkTypeFilter = graphql(`
    query uerPriceListRatioWorkTypeFilter($contractId: Long!) {
        uerPriceListRatioWorkTypeFilter(contractId: $contractId, take: 1000) {
            totalCount
            items {
                value
            }
        }
    }
`);

export const priceListRatioStatusFilter = graphql(`
    query uerPriceListRatioStatusFilter($contractId: Long!) {
        uerPriceListRatioStatusFilter(contractId: $contractId, take: 1000) {
            totalCount
            items {
                value
            }
        }
    }
`);

export const priceListFactorsRemoveUnusedRows = graphql(`
    mutation uerRemoveUnusedRatioRows($contractId: Long!) {
        uerRemoveUnusedRatioRows(contractId: $contractId) {
            data {
                count
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerRatioAppliesToCodeFilter = graphql(`
    query uerRatioAppliesToCodeFilter(
        $ratioRowId: Long!
        $order: [FilterValueOfStringSortInput!]
        $where: FilterValueOfStringFilterInput
    ) {
        uerRatioAppliesToCodeFilter(ratioRowId: $ratioRowId, order: $order, where: $where) {
            totalCount
            items {
                value
            }
        }
    }
`);

export const uerRatioAppliesToCodeNameFilter = graphql(`
    query uerRatioAppliesToCodeNameFilter(
        $ratioRowId: Long!
        $order: [FilterValueOfStringSortInput!]
        $where: FilterValueOfStringFilterInput
    ) {
        uerRatioAppliesToCodeNameFilter(ratioRowId: $ratioRowId, order: $order, where: $where) {
            totalCount
            items {
                value
            }
        }
    }
`);

export const uerRatioAppliesToLinkStatusFilter = graphql(`
    query uerRatioAppliesToLinkStatusFilter(
        $ratioRowId: Long!
        $order: [FilterValueOfRatioRecordStatusEnumSortInput!]
    ) {
        uerRatioAppliesToLinkStatusFilter(ratioRowId: $ratioRowId, order: $order) {
            totalCount
            items {
                value
            }
        }
    }
`);
